'use client';

import classNames from 'classnames/bind';
import Image from 'next/image';
import { map } from '@/_utils/map';
import flagRu from '../../../../../public/icons/ru-flag-rounded.webp';
import flagBy from '../../../../../public/icons/by-flag-rounded.webp';
import flagKz from '../../../../../public/icons/kz-flag-rounded.webp';
import flagTj from '../../../../../public/icons/tj-flag-rounded.webp';
import flagUz from '../../../../../public/icons/uz-flag-rounded.webp';
import flagAe from '../../../../../public/icons/ae-flag-rounded.webp';
import flagKg from '../../../../../public/icons/kg-flag-rounded.webp';
import flagAm from '../../../../../public/icons/am-flag-rounded.webp';
import flagGe from '../../../../../public/icons/ge-flag-rounded.webp';
import flagCn from '../../../../../public/icons/cn-flag-rounded.webp';
import flagEt from '../../../../../public/icons/et-flag-rounded.webp';
import styles from './index.module.scss';

export type TCountryCode =
  | 'ru'
  | 'by'
  | 'kz'
  | 'tj'
  | 'uz'
  | 'ae'
  | 'kg'
  | 'am'
  | 'ge'
  | 'cn'
  | 'et';

type TCountryCircleProps = {
  code: TCountryCode;
};

const cn = classNames.bind(styles);
const BLOCK_NAME = 'CountryCircle';

export const CountryCircle = (props: TCountryCircleProps) => {
  const image = map(props.code, {
    ru: flagRu,
    by: flagBy,
    kz: flagKz,
    tj: flagTj,
    uz: flagUz,
    ae: flagAe,
    kg: flagKg,
    am: flagAm,
    ge: flagGe,
    cn: flagCn,
    et: flagEt,
  });

  return (
    <div className={cn(BLOCK_NAME)}>
      <Image src={image.src} alt={props.code} height={80} width={80} />
    </div>
  );
};
